const fragranceDesktop = window.matchMedia('(min-width: 750px)');
const fragranceReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

document.querySelectorAll('media-gallery').forEach((gallery) => {
  const viewer = gallery.querySelector('[id^="GalleryViewer"]');
  const list = gallery.querySelector('[id^="Slider-Gallery"]');
  const getItems = () => Array.from(gallery.querySelectorAll('[id^="GalleryThumbnails"] [data-target]'));
  if (!viewer || !list || getItems().length < 2) return;

  if (fragranceDesktop.matches) {
    list.querySelectorAll('img[loading="lazy"]').forEach((img) => {
      img.loading = 'eager';
    });
  }

  gallery.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest('[id^="GalleryThumbnails"] [data-target] button');
      const forcedDirection = gallery.dataset.swipe;
      delete gallery.dataset.swipe;
      if (!button || !fragranceDesktop.matches || fragranceReducedMotion.matches) return;

      const target = button.closest('[data-target]');
      const from = list.querySelector('.product__media-item.is-active');
      if (!from || from.dataset.mediaId === target.dataset.target) return;

      const items = getItems();
      const fromIndex = items.findIndex((item) => item.dataset.target === from.dataset.mediaId);
      const direction = forcedDirection || (items.indexOf(target) > fromIndex ? 'next' : 'prev');

      const image = from.querySelector('img');
      if (image) {
        const ghost = document.createElement('div');
        ghost.className = `fragrance-swipe-ghost fragrance-swipe-out--${direction}`;
        ghost.style.cssText = `top:${from.offsetTop}px;left:${from.offsetLeft}px;width:${from.offsetWidth}px;height:${from.offsetHeight}px;`;
        const clone = image.cloneNode(true);
        clone.loading = 'eager';
        ghost.appendChild(clone);
        ghost.addEventListener('animationend', () => ghost.remove());
        list.appendChild(ghost);
      }

      requestAnimationFrame(() => {
        const to = list.querySelector('.product__media-item.is-active');
        if (!to || to === from) return;
        to.classList.add(`fragrance-swipe-in--${direction}`);
        to.addEventListener(
          'animationend',
          () => to.classList.remove('fragrance-swipe-in--next', 'fragrance-swipe-in--prev'),
          { once: true }
        );
      });
    },
    true
  );

  const nav = document.createElement('div');
  nav.className = 'fragrance-gallery-nav';

  [
    ['prev', -1, 'Previous image'],
    ['next', 1, 'Next image'],
  ].forEach(([name, step, label]) => {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = `fragrance-gallery-nav__button fragrance-gallery-nav__button--${name}`;
    button.setAttribute('aria-label', label);
    button.innerHTML =
      '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    button.addEventListener('click', () => {
      const items = getItems();
      const current = Math.max(
        items.findIndex((item) => item.querySelector('button[aria-current]')),
        0
      );
      gallery.dataset.swipe = name;
      items[(current + step + items.length) % items.length].querySelector('button').click();
    });
    nav.appendChild(button);
  });

  viewer.appendChild(nav);
});
